module.exports = __webpack_public_path__ + "static/news-11-yonghe-7d89641ac2714aed0df644121f067607.png";